import { BRANDED_TERM_TYPES } from "../constant/drugs";

export const isRxNormDrugBranded = ({ tty }) => Object.values(BRANDED_TERM_TYPES).includes(tty);
export const getDoseFormCategory = (drug) => {
  const routes = [];
  if (drug.isInfusion) routes.push("Infusion");
  if (drug.isSubcutaneous) routes.push("Subcutaneous");
  if (drug.isOralOrOther) routes.push("Oral or Other");
  return routes.join(", ");
};
